import { useState } from 'react';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';

export default function useDeleteVehicleType() {
  const [loading, setLoading] = useState(false);
  async function execute(vehicleTypeId: string) {
    try {
      setLoading(true);
      await api.delete(`v1/backoffice/vehicleType/${vehicleTypeId}`);
      toast.success(ToastMessages.vehicleType.success.deleteVehicleType);
    } catch (error) {
      toast.error(ToastMessages.vehicleType.error.deleteVehicleType);
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
